import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
export const fieldsetContainerStyles = ({ theme, $border, }) => css `
	position: relative;
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['200'])};
	padding: 0;
	margin: 0;
	border: none;

	${$border &&
    css `
		padding: ${pxToRem(theme.spacing[300])};
		padding-bottom: ${pxToRem(theme.spacing['400'])};
		border: ${pxToRem(theme.borderWidth[2])} solid ${theme.colors.light.borderPanelStandard};
		border-radius: ${pxToRem(theme.borderRadius.m)};
	`}
`;
export const FieldsetContainer = styled.fieldset `
	${fieldsetContainerStyles}
`;
export const fieldsetFieldWrapperStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['400'])};
`;
export const FieldsetFieldWrapper = styled.div `
	${fieldsetFieldWrapperStyles}
`;
